<template>
  <div class="paging">
    <a-config-provider :locale="locale">
      <a-pagination
        show-quick-jumper
        :default-current="activePage"
        :total="total"
        :defaultPageSize="12"
        :show-total="(pages) => `共 ${pages} 条`"
        @change="onChange"
      />
    </a-config-provider>
  </div>
</template>

<script>
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
export default {
  props: {
    total: {
      type: Number,
    },
  },
  data() {
    return {
      activePage: 1,
      page: null,
      locale: zhCN,
    };
  },
  methods: {
    onChange(page, limit) {
      this.$emit("handleChange", page);
    },
  },
};
</script>

<style lang="less" scoped>
.paging {
  display: flex;
  justify-content: center;
}
/deep/ .ant-pagination-item {
  border: none;
  font-weight: bold;
  font-size: 16px;
  background: url("../../assets/images/paging/icon-page-default@2x.png")
    no-repeat;
  background-size: 100% 100%;
  width: 44px;
  height: 44px;
  line-height: 44px;
}

/deep/ .ant-pagination-total-text {
  color: #333333;
  font-size: 16px;
}

/deep/ .ant-pagination-options-quick-jumper {
  color: #333333;
  font-size: 16px;
}

/deep/ .ant-pagination-item-active {
  width: 44px;
  height: 44px;
  background: url("../../assets/images/paging/icon-page-select@2x.png")
    no-repeat;
  background-size: 100% 100%;
}

/deep/ .ant-pagination-prev .ant-pagination-item-link {
  background: url("../../assets/images/paging/icon-page-pre@2x.png") no-repeat;
  background-size: 100% 100%;
  border: none;
  color: rgba(255, 255, 255, 0);
}

/deep/ .ant-pagination-next .ant-pagination-item-link {
  background: url("../../assets/images/paging/icon-page-next@2x.png") no-repeat;
  background-size: 100% 100%;
  border: none;
  color: rgba(255, 255, 255, 0);
}
/deep/ .ant-pagination-prev .ant-pagination-item-link:hover {
  color: rgba(255, 255, 255, 0);
}

/deep/ .ant-pagination-next .ant-pagination-item-link:hover {
  color: rgba(255, 255, 255, 0);
}

/deep/ .ant-pagination-options-quick-jumper input {
  width: 40px;
  height: 40px;
}
</style>